export default "__VITE_ASSET__DAW777Q2__"